__turbopack_context__.v({
  "container": "viewer-module-scss-module__hjV-Bq__container",
  "errorMessage": "viewer-module-scss-module__hjV-Bq__errorMessage",
  "errorMessageWrapper": "viewer-module-scss-module__hjV-Bq__errorMessageWrapper",
  "noImageIcon": "viewer-module-scss-module__hjV-Bq__noImageIcon",
  "panelContent": "viewer-module-scss-module__hjV-Bq__panelContent",
  "panelEmptyMessage": "viewer-module-scss-module__hjV-Bq__panelEmptyMessage",
  "panelTitle": "viewer-module-scss-module__hjV-Bq__panelTitle",
  "readingToolsPanelsWrapper": "viewer-module-scss-module__hjV-Bq__readingToolsPanelsWrapper",
  "retryButton": "viewer-module-scss-module__hjV-Bq__retryButton",
  "statusPane": "viewer-module-scss-module__hjV-Bq__statusPane",
  "viewerContainer": "viewer-module-scss-module__hjV-Bq__viewerContainer",
});
